import { Package } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const PackageIcon = createLucideIcon(Package);
